import { PublicController } from './public.controller';
import template from './public.html';

export const publicComponent = {
  name: 'publicComponent',
  restrict: 'E',
  template,
  controller: PublicController,
  controllerAs: 'vm',
  bindings: {}
};
